// action - state management
import { ACCOUNT_INITIALIZE, LOGIN, LOGOUT, UPDATE } from './actions';

export const initialState = {
    token: '',
    isLoggedIn: false,
    isInitialized: false,
    user: null,
    role: null
};

//-----------------------|| ACCOUNT REDUCER ||-----------------------//

const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACCOUNT_INITIALIZE: {
            const { isLoggedIn, user, token, role } = action.payload;
            return {
                ...state,
                role,
                isLoggedIn,
                isInitialized: true,
                token,
                user
            };
        }
        case LOGIN: {
            const { user, role } = action.payload;
            return {
                ...state,
                isLoggedIn: true,
                user,
                role
            };
        }
        case UPDATE: {
            const { user } = action.payload;
            return {
                ...state,
                user
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isLoggedIn: false,
                token: '',
                user: null,
                role: null

            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
